import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Checkbox from "@visa/vds/checkbox";
import Col from "@visa/vds/col";
import Fieldset from "@visa/vds/fieldset";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import Icon from "@visa/vds/icon";
import Row from "@visa/vds/row";
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import MCSControlCheckbox from "../../../../components/MCSControlCheckbox";
import MCSControlEditor from "../../../../components/MCSControlEditor";
import MCSControlFileUpload from "../../../../components/MCSControlFileUpload";
import MCSControlInput from "../../../../components/MCSControlInput";
import MCSControlSelect from "../../../../components/MCSControlSelect";
import MCSControlTextArea from "../../../../components/MCSControlTextArea";
import MCSLoading from "../../../../components/MCSLoading";
import { LibraryAdminApi } from "../../../../services/library.admin.service";
import { FileHelper } from "../../../../_helpers/FileHelper";
import { FormHelper } from "../../../../_helpers/FormHelper";
import { LoadingSpinner } from "./LoadingSpinner";
import "./PostForm.css";
import PostFormNoticeTooltip from "./PostFormNoticeTooltip";
import PostFormTagSection from "./PostFormTagSection";

const PostForm = (props) => {
  const defaultValues = {
    post: props.post,
    libraryPostUrl: (props.post.libraryPostUrl == null ? { url: "" } : props.post.libraryPostUrl),
    libraryPostFile: props.post.libraryPostFile,
  };

  const [disableSaveButton, setDisableSaveButton] = useState(false);

  const {
    control,
    handleSubmit,
    setError,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  const { promiseInProgress } = usePromiseTracker();

  const [displayNotice, setDisplayNotice] = useState(
    defaultValues.post.notice != null
  );

  const [isDynamicUrl, setIsDynamicUrl] = useState(
    defaultValues.post.isDynamicUrl != null
  );

  const [formData, setFormData] = useState(getValues());
  const [libraryPostFile, setLibraryPostFile] = useState(
    defaultValues.libraryPostFile
  );

  const updateFormData = () => {
    setFormData(getValues())
  };

  const onSubmit = () => {
    let postDto = cloneDeep(formData.post);
    if (!displayNotice) postDto.notice = null;
    postDto.libraryPostUrl = formData.libraryPostUrl;
    postDto.libraryPostFile = libraryPostFile;
    postDto.libraryPostLibraryTags = props.post.libraryPostLibraryTags;
    trackPromise(
      LibraryAdminApi.savePost(postDto)
        .then((res) => {
          props.alertObj.setSuccessMessage("Save success!");
          props.redirectToCategory();
        })
        .catch((error) => {
          props.alertObj.setErrorMessage(error.response.data.result);
        })
    );
  };

  const handleClickAddTag = async (tagIdToAdd) => {
    if (tagIdToAdd == "") return false;

    let checkExist = props.post.libraryPostLibraryTags.filter(
      (t) => t.libraryTagId == tagIdToAdd
    );
    if (checkExist.length !== 0) return false;

    let tagToAdd = {
      libraryPostId: props.post.id,
      libraryTagId: tagIdToAdd,
      libraryTag: props.tagList.filter((t) => t.id == tagIdToAdd)[0],
    };
    let updatedTags = props.post.libraryPostLibraryTags.concat(tagToAdd);
    props.setPost({ ...props.post, libraryPostLibraryTags: updatedTags });
  };

  const handleClickRemoveTag = async (event) => {
    let tagName = event.target.getAttribute("dataid");
    let updatedTags = props.post.libraryPostLibraryTags.filter(
      (t) => t.libraryTag.name != tagName
    );
    props.setPost({ ...props.post, libraryPostLibraryTags: updatedTags });
  };

  const handleFileSelected = async (event) => {
    if (event.target.files.length > 0) {
      var fileName = event.target.files[0].name;
      var fileBytes = await FileHelper.ConvertFileToBase64(
        event.target.files[0]
      );
      setLibraryPostFile({
        fileName: fileName,
        fileData: fileBytes
      });
    }
  };

  const allowDynamicUrl = (post, user) => {
    return (
      post.type == "2" &&
      (post.libraryClassificationId == "3" ||
        post.libraryClassificationId == "5") &&
      user.isSuperAdmin
    );
  };

  const renderErrorMsg = () => {
    FormHelper.renderErrorMsg(errors.post.notice);
  };

  return (
    <>
      {promiseInProgress && <MCSLoading />}
      <Form>
        <Fieldset>
          <FormControl position="right" space="thirty">
            <MCSControlSelect
              name="post.libraryClassificationId"
              control={control}
              rules={{ required: true }}
              label="Library Object Classification"
              handleChange={updateFormData}
              options={
                <>
                  <option value="" disabled hidden>
                    - Select -
                  </option>
                  {props.classificationList &&
                    props.classificationList.map((item, k) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </>
              }
            />
          </FormControl>
          {formData.post.libraryClassificationId == "3" && (
            <FormControl position="right" space="seventy">
              <MCSControlSelect
                name="post.productId"
                control={control}
                rules={{
                  required: formData.post.libraryClassificationId == "3",
                }}
                label="Select product of the subscription"
                handleChange={updateFormData}
                options={
                  <>
                    <option value="" disabled hidden>
                      - Select -
                    </option>
                    {props.productList &&
                      props.productList.map((item, k) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                  </>
                }
              />
            </FormControl>
          )}
          <Row>
            <FormControl position="right" space="thirty">
              <MCSControlSelect
                name="post.type"
                control={control}
                rules={{ required: true }}
                label="Library Object Type"
                handleChange={updateFormData}
                options={
                  <>
                    <option value="" disabled hidden>
                      - Select -
                    </option>
                    <option value="1">Document</option>
                    <option value="2">Link</option>)
                  </>
                }
              />
            </FormControl>
            {allowDynamicUrl(formData.post, props.user) && (
              <FormControl
                className="checkbox-isDynamicUrl"
                position="right"
                space="thirty"
              >
                <MCSControlCheckbox
                  name="libraryPostUrl.isDynamicUrl"
                  control={control}
                  label="Is Dynamic Url"
                  handleChange={updateFormData}
                ></MCSControlCheckbox>
              </FormControl>
            )}
          </Row>
          <Row>
            {formData.post.type == "1" && (
              <>
                <MCSControlFileUpload
                  name="libraryPostFile.fileName"
                  control={control}
                  handleChange={handleFileSelected}
                  rules={{
                    required: true,
                  }}
                  accept={".docx,.doc,.pdf,.xlsx,.pptx"}
                  fileName={libraryPostFile && libraryPostFile.fileName}
                />
                <LoadingSpinner area="file-upload" />
              </>
            )}
            {formData.post.type == "2" && (
              <FormControl position="right" space="seventy">
                <MCSControlInput
                  name="libraryPostUrl.url"
                  control={control}
                  handleChange={updateFormData}
                  rules={{
                    required: true,
                    maxLength: 1000,
                    validate: {
                      isEmpty: (v) =>
                        FormHelper.isStringBlank(v) ||
                        "The field cannot be blank",
                    },
                  }}
                  label="Url"
                />
              </FormControl>
            )}
          </Row>
          <Row>
            <FormControl>
              <Checkbox
                checked={displayNotice}
                name="displayNotice"
                label="Display Notice"
                onChange={(e) => {
                  setDisplayNotice(!displayNotice);
                }}
              />
              {displayNotice && <PostFormNoticeTooltip />}
            </FormControl>
          </Row>
          <Row>
            {displayNotice && (
              <>
                <FormControl
                  position="left"
                  space="seventy"
                  className={
                    errors.post && errors.post.notice ? "vds-state--error" : ""
                  }
                >
                  <MCSControlEditor
                    name="post.notice"
                    control={control}
                    handleChange={updateFormData}
                    rules={{
                      required: displayNotice,
                      maxLength: 2000,
                    }}
                  />
                  {errors.post && errors.post.notice && (
                    <span
                      style={{ display: "flex", paddingTop: "0.3rem" }}
                      className="vds-input-message vds-state--error"
                      id="input-message-error-h2s_Tyqe3y"
                    >
                      <Icon name="error" resolution="tiny" />
                      {FormHelper.renderErrorMsg(errors.post.notice)}
                    </span>
                  )}
                </FormControl>
              </>
            )}
          </Row>
          <FormControl>
            <MCSControlInput
              name="post.title"
              maxLength="100"
              label="Display Title"
              control={control}
              handleChange={updateFormData}
              rules={{
                required: true,
                validate: {
                  isEmpty: (v) =>
                    FormHelper.isStringBlank(v) || "The field cannot be blank",
                },
              }}
            />
          </FormControl>
          <FormControl>
            <MCSControlTextArea
              name="post.description"
              control={control}
              handleChange={updateFormData}
              rows="1"
              autoResize
              label="Description"
              rules={{
                required: false,
                maxLength: 500,
                validate: {
                  isEmpty: (v) =>
                    FormHelper.isStringBlank(v) || "The field cannot be blank",
                },
              }}
            />
          </FormControl>
          <PostFormTagSection
            tagList={props.tagList}
            filtertagList={props.filtertagList}
            libraryPostLibraryTags={props.post.libraryPostLibraryTags}
            handleClickAddTag={handleClickAddTag}
            handleClickRemoveTag={handleClickRemoveTag}
          ></PostFormTagSection>
        </Fieldset>
        <Row>
          <Col>
            <ButtonGroup direction="right">
              <ButtonText
                disabled={disableSaveButton}
                colorScheme="primary"
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                Save
              </ButtonText>
              <ButtonText
                colorScheme="tertiary"
                onClick={props.redirectToCategory}
              >
                Cancel
              </ButtonText>
            </ButtonGroup>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default PostForm;
